import { get } from 'lodash';
import React from 'react';

import { months, years } from 'src/constants';
import * as ResourcesAPI from 'src/services/resources';
import { BaseBox, Flex, Text, ErrorMessage } from 'src/kit';
import { FormikInput, FormikCombobox } from '@src/features/common';

export const Education = React.memo(({ resourcesStore, degreeValues, index, errors }) => {
  return (
    <BaseBox mr={20} flex="0 1 calc(100% - 120px)">
      <FormikCombobox
        isFast
        loadItems={ResourcesAPI.getUniversities}
        name={`degrees_attributes.${index}.university`}
        placeholder="Institution"
        mb={20}
      />
      <FormikCombobox
        name={`degrees_attributes.${index}.degree`}
        isFast
        items={resourcesStore.degrees}
        placeholder="Degree"
        mb={20}
        flex={1}
      />
      <FormikCombobox
        name={`degrees_attributes.${index}.major`}
        isFast
        items={resourcesStore.majors}
        placeholder="Field of study"
        mb={20}
        flex={1}
      />
      <FormikInput isFast name={`degrees_attributes.${index}.location`} placeholder="Location" mb={15} />
      <Flex mb={20} alignItems="baseline">
        <FormikCombobox
          name={`degrees_attributes.${index}.startDate.month`}
          items={months}
          placeholder="Month"
          mr={15}
          width={126}
        />
        <FormikCombobox
          name={`degrees_attributes.${index}.startDate.year`}
          items={years}
          placeholder="Year"
          width={100}
        />
        <Text mx={10} color="blueGreyTwo" fontSize={12} lineHeight="40px">
          to
        </Text>
        <div>
          <Flex>
            <FormikCombobox
              name={`degrees_attributes.${index}.endDate.month`}
              items={months}
              placeholder="Month"
              mr={15}
              width={126}
            />
            <FormikCombobox
              name={`degrees_attributes.${index}.endDate.year`}
              items={years}
              placeholder="Year"
              width={100}
            />
          </Flex>
          <ErrorMessage mt={0}>{get(errors, `degrees_attributes.${index}.endDate.global`)}</ErrorMessage>
        </div>
      </Flex>
    </BaseBox>
  );
});
